import * as React from "react";
import LoadingIndicator from "@lululemon/ecom-common/src/components/loading-indicator/loading-indicator";
import { BraQuizDataConsumer } from "../../utils/quizDataContext";

import styles from "./quiz-results-loading-indicator.module.scss";

const QuizResultsLoadingIndicator = () => (
  <BraQuizDataConsumer>
    {({ loadingText }) => (
      <div
        aria-live="polite"
        data-testid="quiz-result-loading"
        className="row center-xs"
      >
        <div className={styles.quizResultsLoadingIndicator}>
          <LoadingIndicator show direction="center" />
          <div>{loadingText}</div>
        </div>
      </div>
    )}
  </BraQuizDataConsumer>
);

export default QuizResultsLoadingIndicator;
